import React from 'react'
import { View } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text } from '@src/components/base'

export interface LabResultProcessingCardProps {
  uploadedAt: string
}

export const LabResultProcessingCard = ({ uploadedAt }: LabResultProcessingCardProps) => {
  const styles = useStyleSheet(themedStyles)

  return (
    <View style={styles.container}>
      <Text type="large">Uploaded at: {uploadedAt}</Text>
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 24,
    backgroundColor: 'theme.background.selected',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'theme.surface.base',
  },
})
